module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#business",
      toString: function () {
        return this.url;
      }
    }